import FetchWrapper from '../Common/Wrappers/FetchWrapper';
import { Service } from '../Common/service.enum';
import Logging from '../../Logging/Logging';
import {
  DomainCName,
  DomainVerification,
  EmailConfiguration,
  TemplateCollection,
} from '../../..';

export default class CorrespondenceRepo {
  private fetch: FetchWrapper;

  constructor(fetch: FetchWrapper) {
    this.fetch = fetch;
  }

  getTemplatesV41(): Promise<TemplateCollection> {
    const apiServiceEndpoint = 'portal/v4.1/ecm-correspondence/templates';

    const queryParams = '';
    const url = `${apiServiceEndpoint}${queryParams}`;

    Logging.Info('GET', url);
    return this.fetch.getFromService<TemplateCollection>(Service.ECM, url);
  }

  getTemplateV41(url: string): Promise<string> {
    Logging.Info('GET', url);
    return this.fetch.get<string>(url);
  }

  getEmailConfigurationV41(): Promise<EmailConfiguration> {
    const apiServiceEndpoint = 'portal/v4.1/ecm-correspondence/email-configuration';

    const queryParams = '';
    const url = `${apiServiceEndpoint}${queryParams}`;

    Logging.Info('GET', url);
    return this.fetch.getFromService<EmailConfiguration>(Service.ECM, url);
  }

  setEmailConfigurationV41(configuration: EmailConfiguration): Promise<void> {
    const apiServiceEndpoint = 'portal/v4.1/ecm-correspondence/email-configuration';

    const queryParams = '';
    const url = `${apiServiceEndpoint}${queryParams}`;

    Logging.Info('PUT', url, configuration);
    return this.fetch.putToService<void>(Service.ECM, url, configuration);
  }

  deleteEmailConfigurationV41(): Promise<void> {
    const apiServiceEndpoint = 'portal/v4.1/ecm-correspondence/email-configuration';

    const queryParams = '';
    const url = `${apiServiceEndpoint}${queryParams}`;

    Logging.Info('DELETE', url);
    return this.fetch.delFromService<void>(Service.ECM, url);
  }

  getDomainVerificationV1(domain: string): Promise<DomainVerification> {
    const apiServiceEndpoint = 'portal/v1/domain/status';

    const queryParams = `?identities=${domain}`;
    const url = `${apiServiceEndpoint}${queryParams}`;

    Logging.Info('GET', url);
    return this.fetch.getFromService<DomainVerification>(Service.CORRESPONDENCE, url);
  }

  getCNameRecordsV1(domain: string): Promise<DomainCName[]> {
    const apiServiceEndpoint = 'portal/v1/domain/cnames';

    const queryParams = `?identities=${domain}`;
    const url = `${apiServiceEndpoint}${queryParams}`;

    Logging.Info('GET', url);
    return this.fetch.getFromService<DomainCName[]>(Service.CORRESPONDENCE, url);
  }
}
